import { useEffect, useRef } from 'react'
import { useChatSendOptional } from '@/features/chat/chatSendContext'

/**
 * Say so in the thread once the user has finished connecting.
 *
 * Gated on this card having *made* the connection, not on the app being
 * connected. Firing on the live connection list would post into every old
 * thread still holding a stale card the moment the app was connected anywhere
 * else — including several at once.
 *
 * The message also asks the agent to carry on, because "connected" on its own
 * leaves the original request still unanswered.
 *
 * @param {string} phase Local phase from useConnectCard.
 * @param {string | null} toolkit
 */
export function useConnectAnnouncement(phase, toolkit) {
  const chat = useChatSendOptional()
  const announced = useRef(false)

  useEffect(() => {
    if (phase !== 'connected' || announced.current || !chat?.sendMessage || !toolkit) return
    announced.current = true
    chat.sendMessage({ text: `${toolkit} is connected now — please continue.`, files: [] })
  }, [phase, chat, toolkit])
}
